import EquipmentStore from "../stores/EquipmentStore"
import AccountStore from "../stores/AccountStore"
import DeviceStore from "../stores/DeviceStore"
import * as hierarchySettingsActions from "../actions/HierarchySettingsActions"
import * as equipmentActions from "../actions/EquipmentActions"
import * as deviceActions from "../actions/DeviceActions"

export function setGlobalHierarchyLevel(selectedLevel) {
    hierarchySettingsActions.receiveHierarchyGlobalItem(selectedLevel)
    const enableEquipment = AccountStore.getCurrentAccountSettings().FeatureSettings.EnableEquipment
    if (enableEquipment) {
        const hierarchyItemId = selectedLevel ? selectedLevel.Id : null
        const limit = EquipmentStore.getLimit()
        equipmentActions.getEquipmentList(hierarchyItemId, 0, limit, "")
    }

    deviceActions.getTopLevelDevices(selectedLevel ? selectedLevel.Id : "", 0, DeviceStore.getLimit(), "")
}
